import { render, staticRenderFns } from "./app.vue?vue&type=template&id=5a53b320&scoped=true"
import script from "./app.component.ts?vue&type=script&lang=ts&external"
export * from "./app.component.ts?vue&type=script&lang=ts&external"
import style0 from "./app.vue?vue&type=style&index=0&id=5a53b320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53b320",
  null
  
)

export default component.exports